import { normalizeUser } from '../../data/users'
import api from '.'

export async function getMe() {
  const res = await api.get('/me', {
    params: {
      include: 'roles.permissions',
    },
  })
  return normalizeUser(res.data.data)
}
